import React, { useEffect, useState } from 'react';
import BackRow from 'components/BackRow/BackRow';
import Card from 'components/Card/Card';
import { EditText, EditDropDown, EditTextArea, EditDate } from 'components/EditText/EditText';
import { get, post, dodelete } from 'lib/comms';
import { DeleteDialog, MessageDialog } from 'components/Dialog/Dialog';
import SearchRow from 'components/SearchRow/SearchRow';
import Table from 'components/Table/Table';
import SwitchBar from 'components/SwitchBar/SwitchBar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import './ChallengePage.css';
import moment from 'moment';

const ChallengePage = (props) => {
    const columns = [
        {
            name: 'Name',
            grow: 2,
            selector: 'last_name',
            sortable: true,
            format: (row) => `${row.first_name || ''} ${row.last_name || ''} ${row.deleted_at ? ' (deleted)' : ''}`,
        },
        { name: 'Email', grow: 2, selector: 'email_address', sortable: true },
        {
            name: '',
            selector: 'id',
            sortable: false,
            right: true,
            cell: (row) => (
                <button className="group-remove-member-btn" onClick={() => deleteMember(row)}>
                    <FontAwesomeIcon icon={faMinusCircle} /> Remove Member
                </button>
            ),
        },
    ];
    const columns2 = [
        {
            name: 'Name',
            grow: 2,
            selector: 'last_name',
            sortable: true,
            format: (row) => `${row.first_name || ''} ${row.last_name || ''}`,
        },
        { name: 'Email', grow: 2, selector: 'email_address', sortable: true },
        {
            name: '',
            selector: 'id',
            sortable: false,
            right: true,
            cell: (row) => (
                <button className="group-remove-member-btn group-add-member-btn" onClick={() => addMember(row)}>
                    <FontAwesomeIcon icon={faPlusCircle} /> Add Member
                </button>
            ),
        },
    ];

    const isNew = props.challenge && props.challenge.id === 'new';
    const challengeInit = isNew
        ? {
            id: 'new',
            description: '',
            name: '',
            start_date: moment().format('YYYY-MM-DD'),
            end_date: moment().add(1, 'month').format('YYYY-MM-DD'),
            effort_level: 1,
            target_count: 1,
        }
        : props.challenge;

    const [state, setState] = useState({
        challenge: challengeInit,
        //editing: [isNew],
        editing: [challengeInit],
        showDeleteDialog: false,
        showMessage: null,
        challengemembers: [],
        nonchallengemembers: [],
        addingMembers: isNew,
        isNew,
    });

    const setEditing = async (index) => {
        let { editing, challenge } = state;
        if (editing[index]) {
            // save to db
            if (!challenge.name) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid title', title: 'Save challenge' },
                });
            }
            if (!challenge.description) {
                return setState({
                    ...state,
                    showMessage: { message: 'Please include a valid description', title: 'Save challenge' },
                });
            }
            const resp = await post('cms/challenges', { challenge }, true);
            if (resp && resp.success) {
                props.reload();
                editing[index] = false;
                if (resp.id) {
                    challenge.id = resp.id;
                    setState({ ...state, challenge, isNew: false });
                    props.updateItemCreated();
                }
            } else console.log(resp);
            if (resp.message) {
                setTimeout(
                    () => setState({ ...state, showMessage: { message: resp.message, title: 'Save error' } }),
                    500,
                );
            }
        } else editing[index] = true;
        setState({ ...state, editing });
    };

    useEffect(() => {
        reload();
    }, [setState]);

    const reload = async () => {
        let resp = await get(`cms/challengemembers/${state.challenge.id}`, null, true);
        if (resp && resp.challengemembers) setState(prev => ({ ...prev, challengemembers: resp.challengemembers }));
        else console.log(resp);
        // now get the list of users that are not members so we can add them
        resp = await get(`cms/challengemembers/${state.challenge.id}?nonmembers=1`, null, true);
        if (resp && resp.nonchallengemembers) setState(prev => ({ ...prev, nonchallengemembers: resp.nonchallengemembers }));
        else console.log(resp);
    };

    const doDelete = async () => {
        const resp = await dodelete('cms/challenges', { id: state.challenge.id }, true);
        await setState({ showDeleteDialog: false });
        if (resp && resp.success && props.onBack) props.onBack();
        else if (resp.message) {
            setTimeout(() => setState({ showMessage: { message: resp.message, title: 'Delete challenge' } }), 500);
        }
    };

    const deleteMember = async (member) => {
        const resp = await dodelete(`cms/challengemembers/${state.challenge.id}`, { id: member.user_id }, true);
        if (resp.success) {
            const challengemembers = state.challengemembers.filter(
                (challengemember) => challengemember.user_id !== member.user_id,
            );
            const nonchallengemembers = [...state.nonchallengemembers, member];
            setState({ ...state, challengemembers, nonchallengemembers });
        }
        if (resp.message) setState({ ...state, showMessage: { message: resp.message, title: 'Remove member' } });
    };

    const addMember = async (member) => {
        const resp = await post(`cms/challengemembers/${state.challenge.id}`, { id: member.user_id }, true);
        if (resp.success) {
            const nonchallengemembers = state.nonchallengemembers.filter(
                (challengemember) => challengemember.user_id !== member.user_id,
            );
            const challengemembers = [...state.challengemembers, member];
            setState({ ...state, challengemembers, nonchallengemembers });
        }
        if (resp.message) setState({ ...state, showMessage: { message: resp.message, title: 'Remove member' } });
    };

    let { challenge, editing, search, challengemembers, nonchallengemembers, addingMembers } = state;

    let tableData = addingMembers
        ? (nonchallengemembers || [])
        : (challengemembers || []);

    if (search) {
        tableData = tableData.filter(
            (item) =>
                `${item.first_name} ${item.last_name} ${item.username}`
                    .toLowerCase()
                    .includes(search.toLowerCase())
        );
    }
    return (
        <div className="maincontainer">
            <BackRow
                onBack={props.onBack}
                buttonTitle={state.isNew ? null : 'DELETE CHALLENGE'}
                onDelete={() => setState({ ...state, showDeleteDialog: true })}
            />
            <Card title="Challenge information" editing={editing?.[0] ? '1' : undefined} onToggle={() => setEditing(0)}>
                <div className="challenge-edit-outer">
                    <div className="challenge-edit-inner-left">
                        <SwitchBar
                            className="mb-4"
                            editing={editing?.[0] ? '1' : undefined}
                            options={['Active', 'Archived']}
                            values={[1, 0]}
                            value={challenge.active}
                            onChange={(value) => setState({ ...state, challenge: { ...challenge, active: value } })}
                        />
                        <EditText
                            label="Challenge Name"
                            editing={editing?.[0] ? '1' : undefined}
                            onChange={(text) => setState({ ...state, challenge: { ...challenge, name: text } })}
                            value={challenge.name}
                        />
                        <EditTextArea
                            label="Challenge Description"
                            editing={editing?.[0] ? '1' : undefined}
                            onChange={(text) => setState({ ...state, challenge: { ...challenge, description: text } })}
                            value={challenge.description}
                        />
                    </div>
                    <div className="challenge-edit-inner-divider"></div>
                    <div className="challenge-edit-inner-right">
                        <div className="challenge-double-date">
                            <EditDate
                                className="me-2"
                                label="Start Date"
                                editing={editing?.[0] ? '1' : undefined}
                                onChange={(date) =>
                                    setState({ ...state, challenge: { ...challenge, start_date: date } })
                                }
                                value={challenge.start_date}
                            />
                            <EditDate
                                className="ms-2"
                                label="End Date"
                                editing={editing?.[0] ? '1' : undefined}
                                onChange={(date) => setState({ ...state, challenge: { ...challenge, end_date: date } })}
                                value={challenge.end_date}
                                popperPlacement={'bottom-end'}
                            />
                        </div>
                        <EditDropDown
                            className="mb-0"
                            label="Effort Level"
                            options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                            editing={editing?.[0] ? '1' : undefined}
                            onChange={(id) => setState({ ...state, challenge: { ...challenge, effort_level: id } })}
                            value={challenge.effort_level}
                        />
                        <p className="edittext-help">
                            The effort level is measured as a range between 1 and 10. 1 being the lowest level of effort
                            and 10 being the highest.
                        </p>
                        <EditDropDown
                            className="mb-0"
                            label="Target number"
                            options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]}
                            editing={editing?.[0] ? '1' : undefined}
                            onChange={(id) => setState({ ...state, challenge: { ...challenge, target_count: id } })}
                            value={challenge.target_count}
                        />
                        <p className="edittext-help">Enter how many times this achievement should be achieved.</p>
                        <div className="challenge-double-date mt-2">
                            <p className="">
                                Points Value: <b>{(challenge.effort_level || 1) * 50}</b>
                            </p>
                            <p className="">
                                Participants: <b>{challengemembers.length}</b>
                            </p>
                        </div>
                    </div>
                </div>
            </Card>
            {state.isNew ? null : (
                <div className="mt-5">
                    <SearchRow
                        title="Participants"
                        value={search}
                        searchTitle="Search by name or username"
                        onSearch={(search) => setState({ ...state, search })}
                        className={addingMembers ? 'success' : 'primary'}
                        buttonTitle={addingMembers ? 'DONE' : 'ADD MEMBERS'}
                        onBtnClick={() => setState({ ...state, addingMembers: !addingMembers, search: '' })}
                    />
                    <Table columns={addingMembers ? columns2 : columns} data={tableData} noSelect tableID="challenge" />
                </div>
            )}
            {state.showDeleteDialog ? (
                <DeleteDialog
                    item="Challenge"
                    onSuccess={doDelete}
                    onClose={() => setState({ ...state, showDeleteDialog: false })}
                />
            ) : null}
            {state.showMessage ? (
                <MessageDialog
                    message={state.showMessage.message}
                    title={state.showMessage.title}
                    onClose={() => setState({ ...state, showMessage: null })}
                />
            ) : null}
        </div>
    );
};

export default ChallengePage;
